var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.howToId)?_c('div',{staticClass:"main-container h-shadow-m shadow-s h-m-button mh-60",on:{"click":_vm.goToCommunity}},[_c('img',{staticClass:"howTo-icon mh-40 hover-scale",attrs:{"alt":"HowTo icon","src":require("@/assets/HowTo.svg")}}),_c('span',{staticClass:"link"},[_vm._v(" "+_vm._s(_vm.$t('shared.howToTile.community'))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }